<template>
  <v-list class="mt-12">
    <v-list-item class="d-flex justify-center">
      <router-link
        class="nav-link"
        exact
        active-class="nav-link-active"
        :to="{ name: 'dashboardManager' }"
      >
        <v-list-item-icon v-if="!isExpanded">
          <v-icon>mdi-view-dashboard</v-icon>
        </v-list-item-icon>

        <span class="home-link" v-if="isExpanded">Home</span>
      </router-link>
    </v-list-item>
    <v-list-item class="d-flex justify-center">
      <router-link
        class="nav-link"
        active-class="nav-link-active"
        :to="{ name: 'coursesGridManager' }"
      >
        <v-list-item-icon v-if="!isExpanded">
          <v-icon>mdi-school</v-icon>
        </v-list-item-icon>

        <span class="learning-link" v-if="isExpanded">Learning Resources</span>
      </router-link>
    </v-list-item>
    <v-list-item class="d-flex justify-center">
      <router-link
        class="nav-link"
        active-class="nav-link-active"
        :to="{ name: 'documentsListManager' }"
      >
        <v-list-item-icon v-if="!isExpanded">
          <v-icon>mdi-file-document-box-outline</v-icon>
        </v-list-item-icon>

        <span class="documents-link" v-if="isExpanded">Documents</span>
      </router-link>
    </v-list-item>
    <v-list-item class="d-flex justify-center" v-if="this.isPresident()">
      <router-link
        class="nav-link"
        active-class="nav-link-active"
        :to="{ name: 'admin' }"
      >
        <v-list-item-icon v-if="!isExpanded">
          <v-icon>mdi-gavel</v-icon>
        </v-list-item-icon>

        <span class="admin-link" v-if="isExpanded">Admin</span>
      </router-link>
    </v-list-item>
  </v-list>
</template>

<script>
import User from "@/lib/user"
import { UsersAPI } from "@/lib/api"

export default {
  methods: {
    isPresident: function() {
      return User.isPresident()
    }
  },
  props: {
    isExpanded: { type: Boolean, default: true }
  },
  data: function() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
@import "../../scss/variables";

a:link {
  text-decoration: none;
  text-transform: uppercase;
  font-weight: 600;
}

.nav-link {
  color: $dark-grey;
}

.nav-link-active {
  color: $light-grey;
}
.v-list-item {
  line-height: 8em;
}

span.home-link {
  text-transform: none !important;
  font-style: italic;
  color: $dark-grey;
}

span.learning-link {
  color: $dark-blue;
}

span.documents-link {
  color: $orange;
}

span.admin-link {
  color: $light-grey;
}
</style>
